import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ReferralCreditNode, ReferralCreditStatus } from '@app/services/api/api.types';
import { REFERRAL_ENVELOPE_IMAGE } from '@app/utils/referral-assets';

@Component({
  selector: 'referral-credit-banner',
  templateUrl: './referral-credit-banner.component.html',
  styleUrls: ['./referral-credit-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralCreditBannerComponent {
  ReferralCreditStatus = ReferralCreditStatus;

  @Input() referralCredit?: ReferralCreditNode | null;
  /** e.g. "3 months" — from lead context when available */
  @Input() bookingWindowLabel = '3 months';

  REFERRAL_ENVELOPE_IMAGE = REFERRAL_ENVELOPE_IMAGE;

  get showAvailable() {
    return this.referralCredit?.status === ReferralCreditStatus.AVAILABLE;
  }

  get showApplied() {
    return this.referralCredit?.status === ReferralCreditStatus.APPLIED;
  }
}
